<template>
    <div>
        <ul class="panel-box " :class="className">
            <li v-for="(item, index) in listItems" :key="'total-filter-item-' + index" v-if="featureCheck(item.feature)"  @click="sectionChange(item)" :class="{
                'is-active': isSelectedCategory(item.key)
            }">
                <p>{{ item.tlabel ? $t(item.tlabel) : item.label }}</p>
                <div class="text-value align-items-end">
                    <svgicon name="icon-dashboard-sm" width="10" height="10" />
                    <span>{{ getCountData(item.columnMap) }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'dashboard-card',
    props: {
        className: {
            type: String
        },
        countData: {
            type: Object,
        },
        listItems: {
            type: Array,
        },
        selectedCategory: {
            type: Array
        }
    },
    data() {
        return {

        }
    },
    computed: {
        getCountData() {
            return columnMap => this.countData[columnMap];
        },
        isSelectedCategory() {
            return key => this.selectedCategory ? (this.selectedCategory.includes(key)) : false;
        },
    },
    methods: {
        sectionChange(item) {
            this.$emit('section-change', item)
        },
        featureCheck(feature) {
            return feature ? this.$hasFeature(feature) : true;
        }
    }
}
</script>